import { ChromeTab } from "types/chromeTab";
import { ChromeWindow } from "types/chromeWindow";

export default async function getWindowTab(): Promise<ChromeTab> {
  const chromeApi =
  // @ts-ignore
  window.chrome && window.chrome.tabs && window.chrome.windows
  // @ts-ignore
  ? window.chrome
      : undefined;
  if (chromeApi) {
    const activeWindow: ChromeWindow = await chromeApi.windows.getCurrent(),
      activeTabs: ChromeTab[] = await chromeApi.tabs.query({
        active: true,
        currentWindow: true,
      });

    //One active tab per potentially many windows
    for (const tab of activeTabs) {
      if (tab.windowId === activeWindow.id) {
        return tab;
      }
    }
  }

  return {
    active: true,
    id: -1, //TAB_ID_NONE
    url: window.location ? window.location.href : "Unknown url",
  };
}
